import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import './Header.css';
import logo from '../../assets/ftlm23.png';
import { useAuth } from "../auth/AuthContext"; 
import { jwtDecode } from "jwt-decode";

const Header = () => {
  const navigate = useNavigate();
  const { token, logout } = useAuth();
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [searchText, setSearchText] = useState('');


  const messages = [
    "Bienvenue sur FTLM !",
    "Appelez-nous : +216 70685825",
    "Découvrez nos événements et publications !"
  ];

  let userRole = null;
  if (token) {
    try {
      userRole = jwtDecode(token).role;
    } catch (e) {
      console.error("Erreur décodage token", e);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <p>{messages[currentTextIndex]}</p>
      </div>

      {/* MAIN HEADER */}
      <header className="main-header">
        <div className="header-left" onClick={() => navigate('/')}>
          <img src={logo} alt="FTLM Logo" className="logo" />
        </div>

        <div className="header-center">
  <input
    type="text"
    placeholder="Rechercher..."
    className="search-input"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        const lower = searchText.toLowerCase();

        switch (lower) {
          case 'accueil':
            navigate('/Accueil');
            break;
          case 'qui sommes-nous':
          case 'quisommesnous':
            navigate('/QuiSommesNous');
            break;
          case 'événements':
          case 'evenements':
            navigate('/Événements');
            break;
          case 'publications':
            navigate('/Publications');
            break;
          case 'webinaires':
            navigate('/Webinaires');
            break;
          case 'brochures':
            navigate('/Brochures');
            break;
          case 'contact':
            navigate('/Contact');
            break;
            
          default:
            alert('Page non trouvée');
        }
      }
    }}
  />
</div>


        <div className="header-right">
          {/* Réseaux sociaux */}
          <div className="social-icons">
            <a href="https://www.facebook.com/ForumTunisiendesLeadersMaghrebines" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
           
            <a href="https://www.linkedin.com/in/forum-tunisien-des-leaders-maghr%C3%A9bines-a066721b3/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.instagram.com/ftlm.org.tn/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>

          {/* Dashboard admin */}
          {userRole === "admin" && (
            <Link to="/Dashboard" className="header-button dashboard-button">
              Dashboard
            </Link>
          )}

          {/* Connexion / Déconnexion */}
          {token ? (
            <button onClick={logout} className="header-button">
              Se déconnecter
            </button>
          ) : (
            <Link to="/login" className="header-button">
              Se connecter
            </Link>
          )}
        </div>
      </header>

      {/* MENU */}
      <nav className="menu-bar">
        <ul>
          <li><Link to="/Accueil">Accueil</Link></li>
          <li><Link to="/QuiSommesNous">Qui sommes-nous</Link></li>
          <li><Link to="/Événements">Événements</Link></li>
          <li><Link to="/Publications">Publications</Link></li>
          <li><Link to="/Webinaires">Webinaires</Link></li>
          <li><Link to="/Brochures">Brochures</Link></li>
          <li><Link to="/Contact">Contact</Link></li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
